import { IWebsiteProduct } from '@src/components/product-card/product-card.types'

import Button from './Button'
import Color from './Color'
import Image from './Image'
import Link from './Link'
import Product from './Product/Product'
import RichText from './RichText'

interface IGenericContent {
  images: Image[]
  id: string
  title?: string
  content?: RichText
  button?: Button
  titleText?: RichText
  colors: Color[]
  products: IWebsiteProduct[]
  comingSoonProducts?: Product[]
  klaviyoListId?: string
  readonly link?: Link
  readonly price?: number
  overrideProductLink?: string
}

class GenericContent implements IGenericContent {
  readonly images: Image[]
  readonly id: string
  readonly title?: string
  readonly content?: RichText
  readonly button?: Button
  readonly titleText?: RichText
  readonly link?: Link
  readonly colors: Color[]
  readonly products: IWebsiteProduct[]
  readonly comingSoonProducts?: Product[]
  readonly klaviyoListId?: string
  readonly price?: number
  readonly overrideProductLink?: string

  constructor({
    images,
    id,
    title,
    button,
    content,
    titleText,
    link,
    products,
    colors,
    comingSoonProducts,
    klaviyoListId,
    price,
    overrideProductLink,
  }: IGenericContent) {
    this.images = images
    this.id = id
    this.title = title
    this.button = button
    this.content = content
    this.titleText = titleText
    this.link = link
    this.products = products
    this.colors = colors
    this.comingSoonProducts = comingSoonProducts
    this.klaviyoListId = klaviyoListId
    this.price = price
    this.overrideProductLink = overrideProductLink
    return {
      ...this,
    }
  }
}

export default GenericContent
